import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE } from "../seo/siteConfig";

// Per-page SEO: title, description, canonical URL, Open Graph, Twitter cards,
// and optional JSON-LD structured data.
export default function Seo({
  title,
  description,
  noindex = false,
  type = "website",
  jsonLd,
}) {
  const { pathname } = useLocation();
  const canonical = SITE.url + (pathname === "/" ? "" : pathname.replace(/\/$/, ""));
  const fullTitle = title ? `${title} — ${SITE.name}` : SITE.defaultTitle;
  const desc = description || SITE.defaultDescription;
  const image = SITE.url + SITE.ogImage;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content={SITE.locale} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
